import { instance } from './instance'

/**
 * Service für Warenkorb-API-Anfragen
 */
export const cartService = {

  axiosInstance: instance,

  /**
   * Holt einen Warenkorb aus der Session
   * @param {string} sessionId - Session-ID
   * @returns {Promise} Antwort mit Warenkorb-Daten
   */
  getCart(sessionId) {
    return this.axiosInstance.get(`/OrderSessions/${sessionId}/cart`)
  },

  /**
   * Fügt ein Produkt zum Warenkorb hinzu
   * @param {string} sessionId - Session-ID
   * @param {Object} product - Produkt-Daten (sollte OrderItemCreateDto entsprechen)
   * @returns {Promise} Antwort mit aktualisiertem Warenkorb
   */
  addToCart(sessionId, product) {
    return this.axiosInstance.post(`/OrderSessions/${sessionId}/cart`, product)
  },

  /**
   * Entfernt ein Produkt aus dem Warenkorb
   * @param {string} sessionId - Session-ID
   * @param {string} itemId - Item-ID
   * @returns {Promise} Antwort mit aktualisiertem Warenkorb
   */
  removeFromCart(sessionId, itemId) {
    return this.axiosInstance.delete(`/OrderSessions/${sessionId}/cart/items/${itemId}`)
  },

  /**
   * Aktualisiert die Menge eines Produkts im Warenkorb
   * @param {string} sessionId - Session-ID
   * @param {string} itemId - Item-ID
   * @param {number} quantity - Neue Menge
   * @returns {Promise} Antwort mit aktualisiertem Warenkorb
   */
  updateQuantity(sessionId, itemId, quantity) {
    return this.axiosInstance.put(`/OrderSessions/${sessionId}/cart/items/${itemId}`, { quantity })
  },

  /**
   * Leert den Warenkorb
   * @param {string} sessionId - Session-ID
   * @returns {Promise} Antwort mit Status
   */
  clearCart(sessionId) {
    return this.axiosInstance.delete(`/OrderSessions/${sessionId}/cart`)
  }
} 